<template>
  <aside
    :class="['chat-sidebar', { collapsed: !isExpanded }]"
    :style="{ transform: `translateX(${isExpanded ? '0' : '-100%'})` }"
  >
    <div class="sidebar-header header-actions d-flex justify-content-between p-0">
      <button class="btn icon-sidebar p-0" @click="toggleSidebar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-layout-sidebar-inset"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z"
          />
          <path d="M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
        </svg>
      </button>
      <div class="d-flex gap-2 col-11 col-md-12 position-relative p-0">
        <div class="w-100 position-relative">
            <input type="text" @input="getChatHistoryLists" v-model="search" class="form-control w-100"/>
            <button @click="clearChatHistory" class="btn search p-0 position-absolute pr-2">
                <b-icon icon="x"></b-icon>
            </button>
        </div>
        <button v-b-popover.hover.top="$t('title.newChat')" class="btn new-chat p-0" type="button" @click="createNewChat">
          <b-icon icon="pencil-square"></b-icon>
        </button>
      </div>
    </div>
    <div class="chat-sections">
      <div class="chat-section" v-for="(chatHistory, index) in chatHistoryLists" :key="index">
        <h3>{{index}}</h3>
        <ul v-for="(history, index) in chatHistory" :key="index">
          <li class="d-flex align-items-center justify-content-between" :class="{ active: (selectedChat && history.id === selectedChat.id || history?.is_new) }">
            <span @click="selectChat(history)">{{ history.question }}</span>
            <button type="button" class="btn p-0" @click.prevent="deleteChat(history.id)"><b-icon icon="trash"></b-icon></button>
          </li>
        </ul>
      </div>
    </div>
    <div class="sidebar-footer">
      <!-- <button class="upgrade-button">
        <i class="fas fa-arrow-up"></i>
        Upgrade plan to the best models
      </button> -->
    </div>
    <DeleteChatConfirmationModal ref="deleteChatConfirmationModal" @chatHistoryList="getChatHistoryLists"/>
  </aside>
</template>

<script>
import { ref } from 'vue';
import {request} from "@/Util/Request";
import Error from "@/Util/Error";
import DeleteChatConfirmationModal from "@/view/admin/chatAi/modal/DeleteChatConfirmationModal";

export default {
  name: 'ChatSidebar',
  props: {
    selectedChat: Object, // Receives selected chat from parent
  },
   data() {
    return {
        chatHistoryLists: [],
        search: ''
    }
   },
  setup() {
    const isExpanded = ref(true); // Default to expanded state

    const toggleSidebar = () => {
      isExpanded.value = !isExpanded.value;
    };

    return {
      isExpanded,
      toggleSidebar,
    };
  },
  mounted() {
      this.getChatHistoryLists();
  },
  components: {
      DeleteChatConfirmationModal
  },
  methods: {
      async deleteChat(id) {
          this.$refs['deleteChatConfirmationModal'].handleToggleModal(id);
      },
      async createNewChat() {
          this.selectChat({});
          this.$emit('createNewChat');
      },
      async updateLatestChatHistory(question) {
            if(this.chatHistoryLists['Today']) {
                this.chatHistoryLists['Today'][0].question = question;
            } else {
                this.chatHistoryLists['Today'] = [];
                this.chatHistoryLists['Today'].unshift({ id: '', question: question, is_new: true });
                this.chatHistoryLists = {
                    Today: this.chatHistoryLists['Today'],
                    ...this.chatHistoryLists // Spread the rest of the keys
                };
            }
      },
      async clearChatHistory() {
          this.search = '';
          this.getChatHistoryLists();
      },
      async getChatHistoryLists() {
        try {
            const response = await request({
                method: 'get',
                url: `/admin/chat-history-lists?search=${this.search}`,
            });
        
            this.chatHistoryLists = response.data;
            let latestChat = null;
            if (Object.keys(this.chatHistoryLists).length != 0) {
                latestChat = Object.values(this.chatHistoryLists) // Get all values (arrays)
                            .flat()
                            .reduce((latest, chat) => 
                                new Date(chat.created_at) > new Date(latest.created_at) ? chat : latest
                            );
                if (latestChat) {
                    this.selectChat(latestChat);
                }
            } else {
                this.$emit('createNewChat');
            }

            
        } catch (error) {
            
        }
    },
   selectChat(chat) {
      this.$emit("selectChat", chat); // Emit event with selected chat data
    },
  }
};
</script>